import * as components from "./components/index.js";
import * as foundations from "./foundations/index.js";

export const theme: Record<string, any> = {
  ...foundations,
  components: { ...components },
};
